import axios from 'axios';

const ListaTypes = {
  REGISTRO: 'registro',
  MODIFICACION: 'modificacion',
};

const state = {
  solicitudes: null,
  solicitudSeleccionada: null,
  mensaje: '',
  lista: ListaTypes.REGISTRO,
};

const getters = {
  solicitudes: (state) => state.solicitudes,
  solicitudSeleccionada: (state) => state.solicitudSeleccionada,
  mensaje: (state) => state.mensaje,
  lista: (state) => state.lista,
};

const mutations = {
  setSolicitudes: (state, solicitudes) => {
    state.solicitudes = solicitudes;
  },
  setSolicitudSeleccionada: (state, solicitudSeleccionada) => {
    state.solicitudSeleccionada = solicitudSeleccionada;
  },
  setMensaje: (state, mensaje) => {
    state.mensaje = mensaje;
  },
  setLista: (state, lista) => {
    state.lista = lista;
  },
};

const actions = {
  async consultar({ commit }) {
    try {
      const res = await axios.get(`/v1/registro/solicitud/pendientes`);
      const solicitudes = res?.data?.result.map((s) => {
        const parsedData = JSON.parse(s.datosRegistro);
        return {
          id: s.id,
          nombre: parsedData.nombre,
          usuario: parsedData.usuario || parsedData.email,
          rol: s.tipoRegistro.descripcion
        }
      });
      commit('setSolicitudes', solicitudes);
    } catch (error) {
      commit('setSolicitudes', []);
      return error;
    }
  },
  async aprobar({ commit, state }, data) {
    try {
      await axios.put(`/v1/registro/solicitud/${data.id}/aprobar`, { observacion: data.observacion });
      let actualizados = state.solicitudes.filter((solicitud) => solicitud.id !== data.id);
      commit('setSolicitudes', actualizados);
      commit('setMensaje', 'Solicitud aprobada con éxito');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Error al aprobar la solicitud';
      throw new Error(errorMessage);
    }
  },
  async rechazar({ commit, state }, data) {
    try {
      await axios.put(`/v1/registro/solicitud/${data.id}/rechazar`, { motivoRechazo: data.motivoRechazo });
      let actualizados = state.solicitudes.filter((solicitud) => solicitud.id !== data.id);
      commit('setSolicitudes', actualizados);
      commit('setMensaje', 'Solicitud rechazada con éxito');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Error al rechazar la solicitud';
      throw new Error(errorMessage);
      
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { ListaTypes };
